import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import AppRoutes from './Routes';
import { GoogleAnalyticsProvider } from './analytics/GoogleAnalyticsProvider';
import ErrorBoundary from './errors/ErrorBoundary';
import AccountWaitlistDialog from './components/Mainpage/AccountWaitlistDialog';

/* Inside the router, so navigating away from a route that threw recovers
   without a reload. */
const RoutedContent: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary resetKey={pathname}>
      <AppRoutes />
    </ErrorBoundary>
  );
};

const AppContent: React.FC = () => {
  const { themeMode } = useTheme();

  return (
    <BrowserRouter>
      <GoogleAnalyticsProvider>
        <div className={`${themeMode === 'light' ? 'text-ink-inverse' : 'text-ink'} h-screen flex flex-col relative`}>
          <RoutedContent />
        </div>
        <AccountWaitlistDialog />
        {/* <div id="video-engine-container" style={{ display: 'none' }}></div> */}
      </GoogleAnalyticsProvider>
    </BrowserRouter>
  );
};

/* The outer boundary catches the providers and the router themselves, which the
   inner one is mounted beneath and cannot see. */
const Root = () => (
  <ErrorBoundary>
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  </ErrorBoundary>
);

export default Root;
